import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
  budgetSent: ['data']
});

const INITIAL_STATE: { sent?: boolean } = {};

const budgetSent = (state = INITIAL_STATE, action: any) => ({ ...action.data });

export default createReducer(INITIAL_STATE, {
  [Types.BUDGET_SENT as any]: budgetSent
});
